const UNSPECIFIED_OPTION_LABEL = 'Unspecified';

const compareGlobalFilterOptionLabels = (left, right) => {
  if (left === UNSPECIFIED_OPTION_LABEL) {
    return right === UNSPECIFIED_OPTION_LABEL ? 0 : 1;
  }
  if (right === UNSPECIFIED_OPTION_LABEL) {
    return -1;
  }
  return left.localeCompare(right);
};

export const normalizeGlobalFilterOptionLabels = (raw) => {
  if (!Array.isArray(raw)) {
    return [];
  }

  const labels = raw
    .filter((entry) => typeof entry === 'string')
    .map((label) => label.trim())
    .filter(Boolean);

  return Array.from(new Set(labels)).sort(compareGlobalFilterOptionLabels);
};